export const sortByProp = ({ array, propName }: { array: any[]; propName: string }) =>
  array.sort((a, b) => (a[propName] > b[propName] ? 1 : -1));
